/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.querySelector('.jdgm-preview-badge').addEventListener('click', function() {
//   const targetSection = document.querySelector('.jdgm-carousel-wrapper');
//   if (targetSection) {
//     targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//   }
// });

/* Null-check: deze badge staat niet op elke pagina. Zonder check gooit dit
   een TypeError en wordt al het onderstaande overgeslagen. */
var reviewBadge = document.querySelector('.jdgm-preview-badge');
if (reviewBadge) {
  reviewBadge.addEventListener('click', function() {
    var targetSection = document.querySelector('.jdgm-carousel-wrapper');
    if (targetSection) {
      var topOffset = targetSection.getBoundingClientRect().top + window.scrollY - 100; // 100px offset
      window.scrollTo({ top: topOffset, behavior: 'smooth' });
    }
  });
}










/**
 * CAASI Runtime Fixes
 * Injecteert CSS fixes die niet via custom.css werken door caching/specificity
 */
(function() {
  var style = document.createElement('style');
  style.id = 'caasi-runtime-fixes';
  style.textContent = [
    /* Afbeelding hoeken afronden */
    '.product-gallery__carousel-item { border-radius: 16px !important; overflow: hidden !important; }',
    '.product-gallery__size-limiter { border-radius: 16px !important; overflow: hidden !important; }',
    '.product-gallery__size-limiter .aspect-ratio { border-radius: 16px !important; overflow: hidden !important; }',
    /* Fit-check strepen: alleen zo lang als content */
    '.caasi-fit-check .caasi-fit-intro { width: fit-content !important; max-width: 100% !important; }',
    '.caasi-fit-columns > div:first-child { width: fit-content !important; max-width: 100% !important; }',
    '.caasi-fit-columns > div:last-child { width: fit-content !important; max-width: 100% !important; }',
    /* Euro spatie */
    '.price { letter-spacing: normal; }'
  ].join('\n');
  document.head.appendChild(style);
  
  /* Euro spatie: zoek alle prijselementen en voeg spatie toe */
  function fixEuroSpacing() {
    document.querySelectorAll('.money, .price, .line-item__price, .line-item__line-price, .cart-recap__total, .cart-recap__price-line, .mini-cart__recap-price-line').forEach(function(el) {
      el.querySelectorAll('*').forEach(function(child) {
        child.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && node.textContent.match(/€\d/)) {
            node.textContent = node.textContent.replace(/€(\d)/g, '€ $1');
          }
        });
      });
      el.childNodes.forEach(function(node) {
        if (node.nodeType === 3 && node.textContent.match(/€\d/)) {
          node.textContent = node.textContent.replace(/€(\d)/g, '€ $1');
        }
      });
    });
  }

  /* Na cart rerender (quantity wijziging) */
  document.addEventListener('cart:rerendered', fixEuroSpacing);
  document.addEventListener('product:added', fixEuroSpacing);
})();

/* Cart-teller: theme.js zet er onvoorwaardelijk een getal in, ook een 0.
   Css met :empty helpt dan niet meer, dus houden we de badge hier bij.

   De observer hangt aan de vaste ouder en niet aan het span zelf, want het
   thema vervangt dat span bij een cart-update en dan zou de observer
   verweesd raken. display gaat met !important omdat het thema zelf
   inline-flex op deze class zet. Er wordt alleen naar inhoud gekeken, niet
   naar attributen, zodat het zetten van display geen nieuwe ronde triggert. */
(function() {
  var houder = document.querySelector('.header__action-item--cart') ||
               document.querySelector('.header__cart-icon');
  if (!houder) return;

  function sync() {
    var badge = houder.querySelector('.header__cart-count');
    if (!badge) return;
    var aantal = parseInt(badge.textContent, 10);
    if (!aantal || isNaN(aantal)) {
      badge.style.setProperty('display', 'none', 'important');
    } else {
      badge.style.removeProperty('display');
    }
  }

  sync();
  document.addEventListener('cart:rerendered', sync);
  document.addEventListener('product:added', sync);

  if (window.MutationObserver) {
    new MutationObserver(sync).observe(houder, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
})();


/* ==========================================================================
   VOORRAADSORTERING IN PRODUCTLIJSTEN (19-08-2026)

   De uurlijkse cron sorteert echte collecties (op voorraad eerst), maar
   /collections/vendors?q=Merk is geen echte collectie: die lijst komt van
   Shopify zelf en houdt geen rekening met voorraad. Daardoor stonden er
   uitverkochte artikelen middenin "alles van dit merk".

   Herkenning: het thema rendert per kaart .product-item__inventory met
   .inventory--high (op voorraad) of .inventory--low (bijna op). Ontbreken
   allebei, dan is het uitverkocht.

   Let op: dit sorteert binnen de getoonde pagina. Bij paginering blijft een
   uitverkocht artikel op zijn eigen pagina staan, achteraan.
   ========================================================================== */
(function () {
  function isUitverkocht(kaart) {
    var v = kaart.querySelector('.product-item__inventory');
    if (!v) return false;
    return !(v.classList.contains('inventory--high') || v.classList.contains('inventory--low'));
  }

  function sorteer(lijst) {
    if (!lijst || lijst.getAttribute('data-caasi-gesorteerd') === '1') return 0;
    var kaarten = [].slice.call(lijst.children).filter(function (k) {
      return k.classList && k.classList.contains('product-item');
    });
    if (kaarten.length < 2) return 0;

    var uit = kaarten.filter(isUitverkocht);
    if (!uit.length || uit.length === kaarten.length) {
      lijst.setAttribute('data-caasi-gesorteerd', '1');
      return 0;
    }
    // stabiel: onderlinge volgorde blijft, uitverkocht schuift naar achteren
    uit.forEach(function (k) { lijst.appendChild(k); });
    lijst.setAttribute('data-caasi-gesorteerd', '1');
    return uit.length;
  }

  function sorteerAlles() {
    var lijsten = document.querySelectorAll('.product-list');
    for (var i = 0; i < lijsten.length; i++) {
      // carousels laat de sectie zelf sorteren vóór flickity start;
      // achteraf herschikken zou de carousel-layout breken
      if (lijsten[i].classList.contains('flickity-enabled')) continue;
      if (lijsten[i].classList.contains('product-list--scrollable')) continue;
      sorteer(lijsten[i]);
    }
  }

  window.CaasiVoorraad = { sorteer: sorteer, isUitverkocht: isUitverkocht };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sorteerAlles);
  } else {
    sorteerAlles();
  }
  document.addEventListener('shopify:section:load', sorteerAlles);
})();
